var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-marker"},[_c('div',{staticClass:"training-marker__outer"}),_c('div',{staticClass:"training-marker__dot"})])}]

export { render, staticRenderFns }